import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ISubBrandCollection } from 'src/app/shared/Models/ICategories';
import { IExtendPagination } from 'src/app/shared/Pagination/IPagination';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-subBrand',
  templateUrl: './subBrand.component.html',
  styleUrls: ['./subBrand.component.scss']
})
export class SubBrandComponent implements OnInit {


  public subBrandCollection$: Observable<ISubBrandCollection[]>;
  @Output() pagination: EventEmitter<IExtendPagination> = new EventEmitter<IExtendPagination>();
  @Output() brandName: EventEmitter<string> = new EventEmitter<string>();





  public collapse: boolean = true;

  constructor(private _homeService: HomeService) {
  }


  ngOnInit() {
    this.subBrandCollection$ = this._homeService.getSubBrandCollection$;
    this.subBrandCollection$.subscribe(subBrandCollection => {

      if (subBrandCollection) {
        subBrandCollection.forEach(c => {
          var code = localStorage.getItem('code');
          if (code) {
            c.subManagementName = c.subManagementNameInKurdish ? c.subManagementNameInKurdish : c.mainSubManagementName;
          } else {
            c.subManagementName = c.mainSubManagementName
          }
        })
      }
    })
  }

  checked(item) {
    // this._homeService.loadsubBrandCollectionCollection(item).subscribe();

    var tt = item;


  }

  OnFilterSubBrandCategory(brandName: string) {


    this.brandName.emit(brandName);


    // this._homeService.searchBrands('noValue',pagination).subscribe(); 

  }

}
